import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'representacao';
const route = {
  listar: `${baseRef}`
};

@Injectable({
  providedIn: 'root'
})
export class RepresentacaoService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private domainCache: DomainCacheService
  ) { }

  listar(): Observable<any> {
    return this.domainCache.getOrLoad(route.listar, () =>
      this.apiService.get<any>(`${route.listar}`, undefined, undefined, true)
    );
  }
}
